import React, { useRef, useState } from "react";
import { Pie } from "react-chartjs-2";
import './ChartConfig';
import { DownloadOutlined } from "@ant-design/icons";

const PieChart = ({ title, dataSource, backgroundColors }) => {
  const chartRef = useRef(null);
  const [hiddenStates, setHiddenStates] = useState(new Array(dataSource.length).fill(false));

  if(!title || !dataSource) return null;

  const labels = dataSource.map((item) => item.grouped);
  const dataValues = dataSource.map((item) => item.count);

  const visibleTotal = dataValues.reduce((acc, value, i) => {
    return hiddenStates[i] ? acc : acc + value;
  }, 0);

  const percentages = dataValues.map((value, i) =>
    hiddenStates[i] ? null : ((value / visibleTotal) * 100).toFixed(1)
  );

  const formattedLabels = labels.map((label, i) => `${'Grouped:'} ${label}`);
  const defaultColors = [ "#A6E5FC", "#F8A4A7", "#BDBBF8", "#70A5FC", "#fbdc7f", "#70e0a8", "#fec24b"];


  const toggleDataset = (index) => {
    setHiddenStates((prev) =>
      prev.map((state, i) => (i === index ? !state : state))
    );
  };
  
  const data = {
    labels: formattedLabels,
    datasets: [
        {
            data: percentages.map((value, i) => (hiddenStates[i] ? '' : value)),
            backgroundColor: backgroundColors || defaultColors,
            hoverOffset: 4,
          },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
        position: "right",
      },
      title: {
        display: true,
        text: title,
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => {
            const index = tooltipItem.dataIndex;
            return `Count: ${dataValues[index]}`; // Show "grouped: count"
          },
        },
      },
      datalabels: {
        color: "#fff",
        font: {
          weight: "bold",
        },
        formatter: (value, context) => {
          const index = context.dataIndex;
          return percentages[index] ? `${percentages[index]}%` : ""; // Show percentage inside the pie chart
        },
      },
    },
  };

  //  Function to Download Chart as PNG or JPG
  const downloadChart = (format) => {
    if (chartRef.current) {
      const chartInstance = chartRef.current;
      const url = chartInstance.toBase64Image(format); // Convert to Base64
      const link = document.createElement("a");
      link.href = url;
      link.download = `premium-paid.${format === "image/png" ? "png" : "jpg"}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <div className="pie-chart">
        {/* Pie Chart */}
        <div className="download-graph" onClick={() => downloadChart("image/png")}><DownloadOutlined /></div>
        <div style={{ width: "100%", height: "100%" }}>
            <Pie ref={chartRef} data={data} options={options} />
        </div>
        
        {/* Custom Legend (Labels) */}
        <div  className="custom-legend">
        {labels.map((label, index) => (
          <div
            key={index}
            onClick={() => toggleDataset(index)}
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "5px",
              cursor: "pointer",
              opacity: hiddenStates[index] ? 0.5 : 1,
            }}
          >
            <div style={{
              width: "12px",
              height: "12px",
              backgroundColor: defaultColors[index],
              marginRight: "8px",
              borderRadius: "50%",
              border: hiddenStates[index] ? "2px solid #999" : "none",
            }}></div>
            <span style={{ fontSize: "14px", color: "#333" }}>{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PieChart;
